export default __webpack_public_path__ + "static/media/logo-1.ef39bd29.png";